import { bannerTrns } from "../trns";

export const bannerParagraphs = [
  {
    id: 1,
    text: {
      i18nKey: bannerTrns.paragraphFirst
    },
  },
  {
    id: 2,
    text: {
      i18nKey: bannerTrns.paragraphSecond
    },
  },
  {
    id: 3,
    text: {
      i18nKey: bannerTrns.paragraphThird
    },
  },
  {
    id: 4,
    text: {
      i18nKey: bannerTrns.paragraphFourth
    },
  },
]